module.exports = __webpack_public_path__ + "static/img/lge.a97372a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lge.png
// module id = 63KJ
// module chunks = 0